import { render } from "./Requirements.vue?vue&type=template&id=3f91b9c4&scoped=true"
import script from "./Requirements.vue?vue&type=script&lang=js"
export * from "./Requirements.vue?vue&type=script&lang=js"

import "./Requirements.vue?vue&type=style&index=0&id=3f91b9c4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/demo-webapp/demo-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f91b9c4"]])

export default __exports__